var map = {
	"./10_reducedInequality.png": "a2f7",
	"./11_sustainableCitiesAndCommunities.png": "f171",
	"./12_responsibleConsumptionAndProduction.png": "b321",
	"./13_climateAction.png": "ccc5",
	"./14_lifeBelowWater.png": "86f1",
	"./15_lifeOnLand.png": "9f6c",
	"./16_peaceJusticeAndStrongInstitutions.png": "aa45",
	"./17_partnershipForTheGoals.png": "a69c",
	"./1_noPoverty.png": "73e9",
	"./2_zeroHunger.png": "1d1a",
	"./3_goodHealthAndWellBeing.png": "cba5",
	"./4_qualityEducation.png": "62a6",
	"./5_genderEquality.png": "a231",
	"./6_cleanWaterAndSanitation.png": "ce76",
	"./7_affordableAndCleanEnergy.png": "277f",
	"./8_decentWorkAndEconomicGrowth.png": "2345",
	"./9_industryInnovationAndInfrastructure.png": "137c",
	"./affordableAndCleanEnergy.png": "0fb1",
	"./cleanWaterAndSanitation.png": "ad12",
	"./climateAction.png": "b8a7",
	"./decentWorkAndEconomicGrowth.png": "62b3",
	"./genderEquality.png": "7794",
	"./goodHealthAndWellBeing.png": "9547",
	"./industryInnovationAndInfrastructure.png": "9068",
	"./lifeBelowWater.png": "f77f",
	"./lifeOnLand.png": "642d",
	"./noPoverty.png": "84d0",
	"./partnershipForTheGoals.png": "0fcd",
	"./peaceJusticeAndStrongInstitutions.png": "3002",
	"./qualityEducation.png": "8981",
	"./reducedInequality.png": "b7f9",
	"./responsibleConsumptionAndProduction.png": "ee4e",
	"./sustainableCitiesAndCommunities.png": "4c82",
	"./zeroHunger.png": "50fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f39f";